export const loginSuccess = "LOGIN_SUCCESS";
export const loginFailure = "LOGIN_FAILURE";
